/**
 * Validates a generic withdrawal amount. Used by both the normal withdraw flow and the dual collateral flow.
 */

import { BigNumber } from '@ethersproject/bignumber';
import { SiloAsset } from 'app/queries/decoratedSilo';

type Validator = (params: {
  normalizedAmount: BigNumber | null;
  maxAmount: BigNumber;
  selectedAsset: SiloAsset;
  balance: BigNumber;
  isProtected: boolean;
  isFullAmount: boolean;
}) => { message: string } | null;

export const validator: Validator = ({
  normalizedAmount,
  maxAmount,
  selectedAsset,
  balance,
  isProtected,
  isFullAmount,
}) => {
  if (!normalizedAmount) return null;

  const trueAmount = isFullAmount ? balance : normalizedAmount;

  const amountExceedsMax = trueAmount.gt(maxAmount);

  if (!isProtected && trueAmount.gt(selectedAsset.liquidity) && trueAmount.lte(balance)) {
    return {
      message: `There's insufficient ${selectedAsset.symbol} in this silo to withdraw`,
    };
  }

  if (amountExceedsMax && trueAmount.lte(balance)) {
    return { message: 'You cannot withdraw an amount that would cause your position to exceed maximum LTV.' };
  }

  if (amountExceedsMax) {
    return { message: 'You cannot withdraw more than you have deposited.' };
  }

  return null;
};
